/**
 * @generated SignedSource<<44bf0b9c182c93cc97105bf77d61d1db>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LockReservationFlow = "GOODS_RECEPTION" | "SWAP" | "%future added value";
export type lockOnboardingGuardQuery$variables = {
  hubName: string;
  skipOwnedReservations: boolean;
};
export type lockOnboardingGuardQuery$data = {
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
    };
    readonly id: string;
  };
  readonly lockReservations?: {
    readonly nodes: ReadonlyArray<{
      readonly deactivatedAt: any | null | undefined;
      readonly id: string;
      readonly space: {
        readonly hub: {
          readonly id: string;
        };
        readonly id: string;
      };
    }>;
    readonly totalCount: number;
  };
  readonly myUtilizationGrants: {
    readonly nodes: ReadonlyArray<{
      readonly deactivatedAt: any | null | undefined;
      readonly id: string;
      readonly reservation: {
        readonly deactivatedAt: any | null | undefined;
        readonly flow: LockReservationFlow;
        readonly id: string;
        readonly space: {
          readonly hub: {
            readonly id: string;
          };
          readonly id: string;
        };
        readonly subtype: {
          readonly __typename: string;
        };
      };
    }>;
    readonly totalCount: number;
  };
};
export type lockOnboardingGuardQuery = {
  response: lockOnboardingGuardQuery$data;
  variables: lockOnboardingGuardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipOwnedReservations"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/)
  ],
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "pagination",
  "value": {
    "page": 0,
    "pageSize": 1000
  }
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deactivatedAt",
  "storageKey": null
},
v7 = [
  (v2/*:: as any*/),
  (v3/*:: as any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": (v7/*:: as any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "input",
      "value": {}
    },
    (v4/*:: as any*/)
  ],
  "concreteType": "UtilizationGrantPage",
  "kind": "LinkedField",
  "name": "myUtilizationGrants",
  "plural": false,
  "selections": [
    (v5/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UtilizationGrant",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        (v6/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LockReservation",
          "kind": "LinkedField",
          "name": "reservation",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v6/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "flow",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "subtype",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v8/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "myUtilizationGrants(input:{},pagination:{\"page\":0,\"pageSize\":1000})"
},
v10 = {
  "condition": "skipOwnedReservations",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "flow": "SWAP",
            "subtype": "B2B"
          }
        },
        (v4/*:: as any*/)
      ],
      "concreteType": "LockReservationPage",
      "kind": "LinkedField",
      "name": "lockReservations",
      "plural": false,
      "selections": [
        (v5/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LockReservation",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v2/*:: as any*/),
            (v6/*:: as any*/),
            (v8/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "lockReservations(filter:{\"flow\":\"SWAP\",\"subtype\":\"B2B\"},pagination:{\"page\":0,\"pageSize\":1000})"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "lockOnboardingGuardQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v3/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      (v9/*:: as any*/),
      (v10/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "lockOnboardingGuardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": (v7/*:: as any*/),
        "storageKey": null
      },
      (v9/*:: as any*/),
      (v10/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "aede709d25436f7e37affe066bdd8818",
    "id": null,
    "metadata": {},
    "name": "lockOnboardingGuardQuery",
    "operationKind": "query",
    "text": "query lockOnboardingGuardQuery(\n  $hubName: String!\n  $skipOwnedReservations: Boolean!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    hub {\n      id\n    }\n  }\n  myUtilizationGrants(input: {}, pagination: {page: 0, pageSize: 1000}) {\n    totalCount\n    nodes {\n      id\n      deactivatedAt\n      reservation {\n        id\n        deactivatedAt\n        flow\n        subtype {\n          __typename\n        }\n        space {\n          id\n          hub {\n            id\n          }\n        }\n      }\n    }\n  }\n  lockReservations(filter: {subtype: B2B, flow: SWAP}, pagination: {page: 0, pageSize: 1000}) @skip(if: $skipOwnedReservations) {\n    totalCount\n    nodes {\n      id\n      deactivatedAt\n      space {\n        id\n        hub {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b575f8f847e2a3e1f41ac5533b95944";

export default node;
